// src-crsld/components/components.module.js
import config from 'app/config';

import mrscta from './cta/cta.component';
import mrsfooter from './footer/footer.component';
import mrsvideo from '@common/components/video/video.component';
import countdown from '@common/components/countdown/countdown.component';
import opform from '@common/components/opform/opform.component';
import cookieconsent from '@common/components/cookie-consent/cookie-consent.component';

const components = [
  mrscta,
  mrsfooter,
  mrsvideo,
  countdown,
  opform,
  cookieconsent,
];

export default angular
  .module(`${config.appName}.commonComponents`, components)
  .name;